<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        <!-- <h1><i class="text-black-50 fa fa-cogs" aria-hidden="true"></i> จัดการฟอร์ม</h1> -->
        <NavBar></NavBar>
        <div class="container">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <router-link type="button" class="btn btn-light btn-lg pull-right" id="create-form" :to="'formcreate'">
                        <i class="fa fa-plus-circle fa-lg text-success" aria-hidden="true"></i> สร้างฟอร์ม
                    </router-link>
                </div>
            </div>

            <table class="table table-hover mt-2" style="background-color: #fff;">
                <thead>
                    <tr>
                        <th v-for="(item, index) in thead" :key="index" scope="col" :class="item.class">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tbody" :key="index">
                        <th scope="row">{{ index+1 }}</th>
                        <td>{{ item.name }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.userCreate }}</td>
                        <td>{{ item.updated_at }}</td>
                        <td>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" :id="'switch'+index" @click="updateFormWorking(item.id)" v-model="item.working">
                                <label class="custom-control-label" :for="'switch'+index"></label>
                            </div>
                        </td>
                        <td class="text-center">
                            <button type="button" class="btn btn-light mr-2" title="ลบ" @click="validatedCancelForm(item)"><i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-light" title="แก้ไข" @click="editForm(item.id)"><i class="fa fa-pencil fa-lg text-primary" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';

import NavBar from '@/components/NavBar';
export default {
    components:{
        NavBar
    },

    data(){
        return {
            user: null,
            show: false,
            validated: false,
            thead: [
                { name: '#' },
                { name: 'ชื่อฟอร์ม' },
                { name: 'รายละเอียด' },
                { name: 'ผู้สร้าง' },
                { name: 'วันที่แก้ไขล่าสุด' },
                { name: 'การใช้งาน' },
                { name: 'จัดการ', class: 'text-center' },
            ],
            tbody: []
        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getFormActiveAll()
    },

    watch: {

    },

    methods:{
        getFormActiveAll(){
            this.show = true;
            this.tbody = [];
            Api.getFormActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.tbody = data.result.map(it=> {
                        if(it.user_id==this.user.userId){
                            Vue.set(it, 'userCreate', 'ตัวเอง');
                        }else{
                            Vue.set(it, 'userCreate', it.user.name);
                        }

                        Vue.set(it, 'updated_at', this.$moment(it.updated_at).format('LLL'))
                        return it
                    })
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        updateFormWorking(id){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: id,
            };
            Api.updateFormWorking(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        editForm(id){
            this.$router.push({name: 'formupdate', query: { id: id }});
        },

        validatedCancelForm(obj){
            this.$swal({
                title: 'ต้องการลบฟอร์ม',
                text: obj.name+"\nตรวจสอบข้อมูลให้แน่ใจก่อนยืนยัน",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.cancelForm(obj);
                }
            })
        },

        cancelForm(obj){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: obj.id
            };
            Api.cancelForm(token,body).then(res => {
                this.show = false;
                var {data} = res;
                console.log(data)
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.getFormActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        }
    }
}
</script>

<style scoped>
    #create-form {
        border: 1px solid rgba(0, 0, 0, 0.125);
    }
</style>